<template>
  <div class="content">
    <NavBar :navtitle="navtitle" :navBlock="navBlock"></NavBar>
    <div class="paddingContent">
      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form ref="form" :model="listMenuForm" class="searchForm">
            <el-form-item label="會員賬號：" class="searchItem">
              <el-input
                v-model="listMenuForm.userAccount"
                @change="
                  listMenuForm.userAccount = listMenuForm.userAccount.replace(
                    /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\$%\^&\*\\\/]/g,
                    ''
                  )
                "
              ></el-input>
            </el-form-item>
            <el-form-item label="真實姓名：" class="searchItem">
              <el-input v-model="listMenuForm.userRealName"></el-input>
            </el-form-item>
            <el-form-item label="地區：" class="searchItem">
              <el-input v-model="listMenuForm.area"></el-input>
            </el-form-item>
            <el-form-item
              label="手機號碼："
              class="searchItem hidden-lg-and-down"
            >
              <el-input
                v-model="listMenuForm.phone"
                @change="phoneChange"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="會員狀態："
              class="searchItem hidden-lg-and-down"
            >
              <el-select
                v-model="listMenuForm.memberStatus"
                placeholder="請選擇會員狀態"
              >
                <el-option label="全部" value="0"></el-option>
                <el-option label="VIP" value="1"></el-option>
                <el-option label="一般會員" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form :model="listMenuForm" class="searchForm">
            <el-form-item label="手機號碼：" class="searchItem hidden-xl-only">
              <el-input
                v-model="listMenuForm.phone"
                @change="phoneChange"
              ></el-input>
            </el-form-item>
            <el-form-item label="會員狀態：" class="searchItem hidden-xl-only">
              <el-select
                v-model="listMenuForm.memberStatus"
                placeholder="請選擇會員狀態"
              >
                <el-option label="全部" value="0"></el-option>
                <el-option label="VIP" value="1"></el-option>
                <el-option label="一般會員" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="認證狀態：" class="searchItem">
              <el-select
                v-model="listMenuForm.authStatus"
                placeholder="請選擇認證狀態"
              >
                <el-option label="全部" value="4"></el-option>
                <!--     <el-option label="未認證" value="0"></el-option>-->
                <el-option label="已認證" value="1"></el-option>
                <el-option label="待審核" value="2"></el-option>
                <el-option label="審核不通過" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <div class="MenuBtnWrap">
        <div class="btn" @click="search">查詢</div>
        <div class="btn borderBtn" @click="reset">重置</div>
      </div>
      <div class="tableWrap">
        <el-table :data="userInfoList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in userInfoTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>
              <div v-else-if="item.prop === 'authApplyTime'">
                {{ $dayjs(scope.row[item.prop]).format("YYYY-MM-DD HH:mm:ss") }}
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <!-- v-if="scope.row.authorizationCode != '審核不通過'"  -->
              <el-button @click="toEditAuth(scope.row.email)" type="text"
                >查看詳情</el-button
              >
              <!-- <el-button v-else type="text" style="color:#eee;">查看詳情</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "會員",
      navtitle: "實名認證",
      userInfoList: [],
      listMenuForm: {
        userId: "",
        userAccount: "",
        userRealName: "",
        area: "",
        phone: "",
        memberStatus: "0",
        authStatus: "2"
      },
      userInfoTable: [
        {
          prop: "email",
          label: "會員賬號",
          width: "200"
        },
        {
          prop: "nickname",
          label: "暱稱",
          width: ""
        },
        {
          prop: "realname",
          label: "真實姓名",
          width: "80"
        },
        {
          prop: "mobile",
          label: "手機號碼",
          width: "120"
        },
        {
          prop: "country",
          label: "地區",
          width: "120"
        },
        {
          prop: "idcardNumber",
          label: "身份證號碼",
          width: "170"
        },
        {
          prop: "roleMember",
          label: "會籍",
          width: "60"
        },
        {
          prop: "authorizationCode",
          label: "實名認證",
          width: "100"
        },
        // {
        //   prop: 'startTime',
        //   label: '會員開始時間',
        //   width: '170'
        // },{
        //   prop: 'endTime',
        //   label: '會員結束時間',
        //   width: '170'
        // },
        {
          prop: "authApplyTime",
          label: "申请时间",
          width: ""
        }
      ],
      currentPage: 1,
      total: 10,
      dialogVisible: false
    };
  },
  // created() {
  //   let _this = this;
  //   _this.getUserInfoList();
  // },
  activated() {
    let _this = this;
    _this.getUserInfoList();
    // if (
    //   _this.listMenuForm.userId == "" &&
    //   _this.listMenuForm.userAccount === "" &&
    //   _this.listMenuForm.userRealName === "" &&
    //   _this.listMenuForm.area === "" &&
    //   _this.listMenuForm.phone === "" &&
    //   _this.listMenuForm.memberStatus === "0" &&
    //   _this.listMenuForm.authStatus === "2" &&
    //   _this.currentPage === 1
    // ) {
    //   _this.getUserInfoList();
    // }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    phoneChange(val) {
      let _this = this;
      _this.listMenuForm.phone = _this.listMenuForm.phone.replace(/\D/g, "");
    },
    // 获取用户列表和导出所有會員excel的参数
    getparam() {
      let _this = this;
      let area,
        city,
        country,
        role = null;
      // 会员类型
      if (
        _this.listMenuForm.memberStatus === "" ||
        _this.listMenuForm.memberStatus === "0"
      ) {
        role = null;
      } else if (_this.listMenuForm.memberStatus === "1") {
        role = "vip";
      } else if (_this.listMenuForm.memberStatus === "2") {
        role = "user";
      }

      let param = {
        id: _this.listMenuForm.userId === "" ? "" : _this.listMenuForm.userId,
        email:
          _this.listMenuForm.userAccount === ""
            ? null
            : _this.listMenuForm.userAccount,
        realname:
          _this.listMenuForm.userRealName === ""
            ? null
            : _this.listMenuForm.userRealName,
        area: null,
        city: null,
        country:
          _this.listMenuForm.area === "" ? null : _this.listMenuForm.area,
        mobile:
          _this.listMenuForm.phone === "" ? null : _this.listMenuForm.phone,
        role: role,
        pageNo: _this.currentPage,
        pageSize: 10
      };

      if (_this.listMenuForm.authStatus != "4") {
        param.authorizationCode = Number(_this.listMenuForm.authStatus);
      }
      return param;
    },
    // 获取用户列表
    getUserInfoList() {
      let _this = this;
      _this
        .$post(
          "/request/authentication/findAuthList",
          _this.getparam(),
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            _this.total = res.data.allRow;
            res.data.list.forEach(v => {
              v.region =
                (v.country === null ? "" : v.country) +
                " " +
                (v.city === null ? "" : v.city) +
                "" +
                (v.area === null ? "" : v.area);
              v.cardNumber = v.idcardNumber === null ? "" : v.idcardNumber;
              v.roleMember = v.role === "user" ? "一般" : "VIP";
              v.startTime =
                v.startTime == null ? "" : v.startTime.substring(0, 16);
              v.endTime = v.endTime == null ? "" : v.endTime.substring(0, 16);
            });
            _this.userInfoList = res.data.list;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getUserInfoList();
    },
    // 查询
    search() {
      let _this = this;
      _this.currentPage = 1;
      _this.getUserInfoList();
    },
    // 重置
    reset() {
      let _this = this;
      _this.listMenuForm = {
        userId: "",
        userAccount: "",
        userRealName: "",
        area: "",
        phone: "",
        memberStatus: "0",
        authStatus: "2"
      };
      _this.currentPage = 1;
      _this.getUserInfoList();
    },
    // 修改用户实名认证
    toEditAuth(email) {
      let _this = this;
      _this.$router.push(`/authDetails?email=${email}`);
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.content {
  .paddingContent {
    width: 100%;
    .ListMenu {
      display: flex;
    }
    .tableWrap {
      width: 100%;
      margin-top: 0.4rem;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      // .searchItem{
      //     flex: 1;
      // }
    }
    .MenuBtnWrap {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/certificationList.vue